module.exports = __webpack_public_path__ + "static/media/love.b70a74db.png";